import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "coding-standards"
    }}>{`Coding standards`}</h1>
    {
      /* This topic is referred to from Magento 2 code! Don't change the URL without informing engineering! */
    }
    {
      /* Referring file: contributing.md owned by core */
    }
    <p>{`Like many large projects, Adobe Commerce and Magento Open Source have coding standards. Use the coding standards when you contribute to the codebase or create extensions.`}</p>
    <h2 {...{
      "id": "ensuring-the-code-is-compliant"
    }}>{`Ensuring the code is compliant`}</h2>
    <p>{`You can perform Magento Coding Standard inspection with the Magento2 PHP_CodeSniffer standard.`}</p>
    <p>{`To execute the inspection from the command line, run the following command from the project root:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`vendor/bin/phpcs --standard=Magento2 <path to inspect>
`}</code></pre>
    <p>{`To include the Magento Coding Standard as part of PHPStorm inspections:`}</p>
    <ul>
      <li parentName="ul">{`Open PHPStorm preferences`}</li>
      <li parentName="ul">{`Navigate to "Editor" | "Inspections"`}</li>
      <li parentName="ul">{`Select "PHP" | "Quality Tools" | "PHP_CodeSniffer validation"`}</li>
      <li parentName="ul">{`Set "Coding standard" to "Custom" and select the path to `}<inlineCode parentName="li">{`<project_root>/vendor/magento/magento-coding-standard/Magento2/ruleset.xml`}</inlineCode></li>
      <li parentName="ul">{`Check "Installed standards path" and select the path to `}<inlineCode parentName="li">{`<project_root>/vendor/php-compatibility/PHPCompatibility`}</inlineCode></li>
    </ul>
    <h2 {...{
      "id": "contributing"
    }}>{`Contributing`}</h2>
    <p>{`The Magento Coding Standard is created and maintained by the Magento community! See the `}<a parentName="p" {...{
        "href": "contributing.md"
      }}>{`Contribution guide`}</a>{` if you'd like to participate.`}</p>
    <h2 {...{
      "id": "review-the-standards"
    }}>{`Review the standards`}</h2>
    <p>{`Standard details and guides:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "code-demarcation.md"
        }}>{`Code demarcation standard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "php.md"
        }}>{`PHP coding standard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "js.md"
        }}>{`JavaScript coding standard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "jquery-widgets.md"
        }}>{`jQuery widget coding standard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "docblock.md"
        }}>{`DocBlock standard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "js-docblock.md"
        }}>{`JavaScript DocBlock standard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "less.md"
        }}>{`LESS coding standard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "html-style-guide.md"
        }}>{`HTML style guide`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "technical-guidelines.md"
        }}>{`Technical guidelines`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      